import { render } from "./Index.vue?vue&type=template&id=30950e84&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=30950e84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30950e84"

export default script